<template>
  <div>
    <table class="unstriped boss-table-4 boss-calendar-jobs">
      <thead>
        <tr>
          <th class="boss-table-head-center text-nowrap">
            求人ID
          </th>
          <th class="boss-table-head-center text-nowrap width-50">
            管理用求人名
          </th>
          <th class="boss-table-head-center text-nowrap">
            掲載期間
          </th>
          <th class="boss-table-head-center text-nowrap">
            カレンダー設定
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(job, i) in jobs"
          :key="i"
        >
          <td
            class="boss-table-data boss-calendar-jobs-body-id"
            data-test="job-id"
          >
            {{ job.id }}
          </td>
          <td
            class="boss-table-data"
            data-test="name"
          >
            {{ job.name }}
          </td>
          <td
            class="boss-table-data"
            data-test="publishing-date"
          >
            {{ job.startDate | formatDate }} ~ {{ job.endDate | formatDate }}
          </td>
          <td class="boss-table-data">
            <select
              v-model="job.scheduleId"
              data-test="schedule-pull-down"
              class="boss-input-select js-check-default boss-schedule-pull-down"
              @change="updateSchedule(job.id, job.scheduleId)"
            >
              <option
                v-for="(schedule ,j) in schedules"
                :key="`schedule-pull-down-${i}-${j}`"
                :value="schedule.id"
              >
                {{ schedule.name }}
              </option>
              <option :value="null">
                未設定
              </option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val) {
      return dayjs(val).format('YYYY/MM/DD')
    }
  },
  props: {
    jobs: {
      type: Array,
      required: true
    },
    schedules: {
      type: Array,
      required: true
    }
  },
  methods: {
    updateSchedule (jobId, scheduleId) {
      this.$http.secured.put(`/interview_candidate_date/jobs/${jobId}`, scheduleId).then(response => {
        this.$toasted.global.success({ message: 'カレンダー設定を変更しました。' })
        this.$emit('update', jobId, scheduleId)
      })
    }
  }
}
</script>
